// @flow

import React, { Component } from 'react';
import LoadingModal from '../../components/modals/loading';
import type { Props } from '.';
// eslint-disable-next-line no-unused-vars
import logoutStyles from './logout.scss';

class Logout extends Component<Props> {
  props: Props;

  renderLoadingBar = (
    <LoadingModal />
  );

  logout = () => {
    localStorage.clear();
    // eslint-disable-next-line no-restricted-globals
    location.href = '/account/signout';
  }

  renderContent = () => {
    const { history } = this.props;
    return (
      <div className="home-page logout container">
        <button className="btn-top-close" type="button" onClick={history.goBack}>
          X
        </button>
        <div className="row">
          <div className="col logo">
            <span className="logo-image" />
          </div>
        </div>
        <div className="row logout-text">
          <div className="col">
            <h5>Are you sure you want to log out?</h5>
          </div>
        </div>
        <div className="row button">
          <div className="col">
            <button className="btn btn-primary btn-block" type="button" onClick={() => this.logout()}>
              Log out
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <button className="btn btn-default btn-block" type="button" onClick={history.goBack}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      user, authenticating,
    } = this.props;
    return user && !authenticating ?
      this.renderContent() :
      this.renderLoadingBar;
  }
}

export default Logout;
